import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[colorStatus]'
})

export class ColorStatusDirective implements OnChanges {
    @Input('colorStatus') dataInput: any;
    constructor(private el: ElementRef, private renderer: Renderer2) {
    }



    ngOnChanges(changes: SimpleChanges): void {
        this.renderer.setStyle(this.el.nativeElement, 'padding', '10px');
        this.renderer.setStyle(this.el.nativeElement, 'color', 'white');
        this.renderer.setStyle(this.el.nativeElement, 'border-radius', '10px');
        if (this.dataInput.colors?.[this.dataInput.key]) {
            this.renderer.setStyle(this.el.nativeElement, 'background', this.dataInput.colors[this.dataInput.key]?.background);
            this.renderer.setStyle(this.el.nativeElement, 'color', this.dataInput.colors[this.dataInput.key]?.color);
        } else {
            this.renderer.setStyle(this.el.nativeElement, 'background', 'transparent');
            this.renderer.setStyle(this.el.nativeElement, 'color', 'black');
        }
    }

    ngOnInit() {

    }
}